import { gozokiApiWithAuth } from '../gozokiApi'

export const acknowledgeSensorAlert = async (id: number) => {
  const response = await gozokiApiWithAuth.patch(`/sensors/alerts/${id}/acknowledge`)
  return response.data
}
